import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "../../../comn";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

export const BASE = {
    path: `${ptlEnvs.base}/elctdoc/chnl`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/elctdoc/chnls`,
};

export const URLS = {
    ptli0705001q: `${BASE.path}/ptli0705001q`, // list
    ptli0705002s: `${BASE.path}/ptli0705002s`, // regist
    ptli0705003s: `${BASE.path}/ptli0705003s`, // modification
};

export const APIS = {
    // Insert Channel !== 채널 등록 ==!
    insertElctDocChnl: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    // Update Channel !== 채널 수정 ==!
    updateElctDocChnl: (data: any) => {
        return api.put(`${BASE.api}`, {
            ...data,
        });
    },
    // Delete Channel !== 채널 삭제 ==!
    deleteElctDocChnl: (intfChnlId: any, data: any) => {
        return api.put(`${BASE.api}/${intfChnlId}`, {
            ...data,
        });
    },
    // Get a list of Channel. !== 채널 목록을 조회한다.==!
    getElctDocChnlList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Get Channel details. !== 채널 상세정보 조회 ==!
    getElctDocChnl: (intfChnlId: any) => {
        return api.get(`${BASE.api}/${intfChnlId}`);
    },

    // Get a list of document box. !== 문서함 목록을 조회한다.==!
    getElctDocBoxList: (data: any, page: number, size: number) => {
        return api.get(`${process.env.REACT_APP_API_PTLI}/api/v1/ptli/elctdoc/boxs/chnlMap?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
};

export const SF_DOC_CHNL_MGMT_SRCH: TFormSchema = {
    id: "form_docChnlMgmtSrch",
    schema: {
        /* Search keyword Select Option !== 검색어 목록 ==!*/
        kwdSel: {
            type: "select",
            label: "L_KWD",
            options: [
                { label: "L_INTF_CHNL_ID", value: "E" },
                { label: "L_CHNL_NM", value: "A" },
                { label: "L_CHNL_URL_ADDR", value: "B" },
                { label: "L_TRGT_TIN", value: "C" },
                { label: "L_INTF_ID", value: "D" },
            ],
        },
        /* Search keyword Select Option Name !== 검색어 ==!*/
        kwdTxt: {
            type: "text",
            readOnly: true,
        },
        chnlAplyPrcdStatCd: {
            type: "select",
            label: "L_PRCS_STTS",
            all: true,
            area: "comnCd",
            comnCd: "COM0080",
        },
        trgtTpCd: {
            type: "select",
            label: "L_TRGT_TP_NM",
            all: true,
            area: "comnCd",
            comnCd: "COM0069",
        },
        actvtYn: {
            type: "select",
            label: "L_ACTVT_YN",
            all: true,
            area: "comnCd",
            comnCd: "COM0064",
            // defaultValue: "Y"
        },
        sndrcvDvnCd: {
            type: "select",
            label: "L_SNDRCV_DVN_NM",
            all: true,
            area: "comnCd",
            comnCd: "COM0077",
        },
    },
};

export const SG_DOC_CHNL_MGMT_LIST: TGridSchema = {
    id: "grid_docChnlMgmtList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_INTF_CHNL_ID", binding: "intfChnlId", width: "15%" }] },
        { cells: [{ header: "L_CHNL_NM", binding: "chnlNm", width: "25%" }] },
        { cells: [{ header: "L_CHNL_URL_ADDR", binding: "chnlUrlAddr", width: "15%" }] },
        { cells: [{ header: "L_TRGT_TP_NM", binding: "trgtTpCdNm", width: "10%" }] },
        { cells: [{ header: "L_SNDRCV_DVN_NM", binding: "sndrcvDvnCdNm", width: "10%" }] },
        { cells: [{ header: "L_PRCS_STTS", binding: "chnlAplyPrcdStatCdNm", width: "10%" }] },
        { cells: [{ header: "L_ACTVT_YN", binding: "actvtYnNm", width: "5%" }] },
        { cells: [{ header: "L_FRST_REGST_ID", binding: "frstRegstId", width: "10%" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "13%" }] },
    ],
    body: [
        { cells: [{ binding: "intfChnlId" }] },
        { cells: [{ binding: "chnlNm", align: "left" }] },
        { cells: [{ binding: "chnlUrlAddr", align: "left" }] },
        { cells: [{ binding: "trgtTpCdNm" }] },
        { cells: [{ binding: "sndrcvDvnCdNm" }] },
        { cells: [{ binding: "chnlAplyPrcdStatCdNm" }] },
        { cells: [{ binding: "actvtYnNm" }] },
        { cells: [{ binding: "frstRegstId" }] },
        { cells: [{ binding: "frstRgsrDtm", type: "datetime" }] },
    ],
};

export const SF_DOC_CHNL_MGMT_INFO: TFormSchema = {
    id: "form_docChnlMgmtInfo",
    schema: {
        intfId: { type: "text", label: "L_INTF_ID", required: true },
        intfChnlId: { type: "text", label: "L_INTF_CHNL_ID", required: true, maxLength: 20 },
        chnlNm: { type: "text", label: "L_CHNL_NM", required: true },
        chnlIpAddr: { type: "text", label: "L_IP_ADDR" },
        chnlPortValue: {
            type: "text",
            label: "L_PORT_VAL",
            maxLength: 10,
            pattern: { value: /[0-9]$/, message: "msg.ptl.00677" },
        },
        chnlUrlAddr: { type: "text", label: "L_CHNL_URL_ADDR", required: true },
        trgtTin: {
            type: "text",
            label: "L_TRGT_TIN",
            maxLength: 9,
            minLength: 7,
            pattern: { value: /[0-9]$/, message: "msg.ptl.00677" },
            required: false,
        },
        rtrnRsn: { type: "textarea", label: "L_RTRN_RSN" },
        trgtTpCd: { type: "select", label: "L_TRGT_TP_NM", area: "comnCd", comnCd: "COM0069", required: true },
        chnlAplyPrcdStatCd: { type: "select", label: "L_PRCS_STTS", area: "comnCd", comnCd: "COM0080", required: true },
        sndrcvDvnCd: {
            type: "radio",
            label: "L_SNDRCV_DVN_NM",
            area: "comnCd",
            comnCd: "COM0077",
            required: true,
            excludes: ["C"],
        },
        chnlPrtclNm: { type: "radio", label: "L_PRTCL_NM", area: "comnCd", comnCd: "COM0071", required: true },
        actvtYn: {
            type: "radio",
            label: "L_ACTVT_YN",
            area: "comnCd",
            comnCd: "COM0064",
            defaultValue: "Y",
            required: true,
        },
        cntyCd: { type: "code", label: "L_CNTY_CD", area: "cntyCd", popupSize: "md" },
        coCd: { type: "code", label: "L_CO_CD", area: "coDclaCd", popupSize: "md" },
        frstRegstId: { type: "text", label: "L_FRST_REGST_ID" },
        frstRgsrDtm: { type: "datetime", label: "L_FRST_RGSR_DTM" },
        gwayApiKey: { type: "textarea", label: "L_API_KEY" },
        gwayUrlAddr: { type: "text", label: "L_URL_ADDR" },
        chnlKeyCn: { type: "textarea", label: "L_CHNL_KEY" },

        govesbUseYn: {
            type: "radio",
            label: "L_GOVESB_USE_YN",
            area: "comnCd",
            comnCd: "COM0064",
            defaultValue: "N",
        },
        apiCd: { type: "text", label: "L_API_CD", readOnly: true },
        pshCd: { type: "text", label: "L_PSH_CD", readOnly: true },

        ifauthTpCd: { type: "select", label: "L_IFAUTH_TP_CD", area: "comnCd", comnCd: "COM0083", defaultValue: "N", required: true },
        tknUrl: { type: "text", label: "L_TKN_URL", },
        tknId: { type: "text", label: "L_TKN_ID", },
        tknSecrtKeyValue: { type: "text", label: "L_TKN_SECRT_KEY_VALUE", },


        cpaId: { type: "text", label: "L_CPA_ID" },
        cpaCntyCd: { type: "code", label: "L_CPA_CNTY", area: "cntyCd", popupSize: "md" },
        cpaSndrId: { type: "text", label: "L_CPA_SNDR_ID" },
        cpaSndrPwd: { type: "text", label: "L_CPA_SNDR_PWD" },
        cpaRcvrId: { type: "text", label: "L_CPA_RCVR_ID" },
        cpaRcvrPwd: { type: "text", label: "L_CPA_RCVR_PWD" },
        parnEnpo: { type: "text", label: "L_PARN_ENPO" },
        parnIp: { type: "text", label: "L_PARN_IP" },
        ovstCagYn: {
            type: "radio",
            label: "L_OVST_CAG_CHK",
            options: [
                { label: "Y", value: "Y" },
                { label: "N", value: "N" },
            ],
            defaultValue: "N",
        },
        ipYn: {
            type: "radio",
            label: "L_IP_CHK",
            options: [
                { label: "Y", value: "Y" },
                { label: "N", value: "N" },
            ],
            defaultValue: "N",
        },
        tansadBlckYn: {
            type: "radio",
            label: "L_TANSAD_BLCK",
            options: [
                { label: "Y", value: "Y" },
                { label: "N", value: "N" },
            ],
            defaultValue: "N",
        },
    },
};

export const SG_DOC_TRSC_INFO_LIST: TGridSchema = {
    id: "grid_docTrscList",
    options: { edit: false, checkbox: true },
    head: [
        { cells: [{ header: "L_INTF_ID", binding: "intfId", width: "*", required: true }] },
        { cells: [{ header: "L_INTF_NM", binding: "intfNm", width: "*", required: true }] },
        { cells: [{ header: "L_SNDRCV_TP_NM", binding: "sndrcvTpCd", width: "*", required: true }] },
        { cells: [{ header: "L_SNDR_NM", binding: "sndrNm", width: "*", required: true }] },
        { cells: [{ header: "L_RECPT_NM", binding: "apiUrlAddr", width: "*", required: true }] },
        { cells: [{ header: "L_API_URL_ADDR", binding: "apiUrlAddr", width: "*", required: true }] },
        { cells: [{ header: "L_API_CD", binding: "apiCd", width: "*" }] },
        { cells: [{ header: "L_PSH_CD", binding: "pshCd", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "intfId", type: "text" }] },
        { cells: [{ binding: "intfNm", type: "text" }] },
        { cells: [{ binding: "sndrcvTpCd", type: "code", area: "comnCd", comnCd: "COM0070", viewType: "label" }] },
        { cells: [{ binding: "sndrNm", type: "text" }] },
        { cells: [{ binding: "rcvrNm", type: "text" }] },
        { cells: [{ binding: "apiUrlAddr", type: "text" }] },
        { cells: [{ binding: "apiCd", type: "text" }] },
        { cells: [{ binding: "pshCd", type: "text" }] },
    ],
};

export const SG_TANCIS_ED_RCVR_INFO_LIST: TGridSchema = {
    id: "grid_docTrscList",
    options: { edit: false, checkbox: true },
    head: [
        { cells: [{ header: "L_INTF_ID", binding: "intfId", width: "*", required: true }] },
        { cells: [{ header: "L_INTF_NM", binding: "intfNm", width: "*", required: true }] },
        { cells: [{ header: "L_SNDRCV_TP_NM", binding: "sndrcvTpCd", width: "*", required: true }] },
        { cells: [{ header: "L_SNDR_ID", binding: "intfSndrId", width: "*", required: true }] },
        { cells: [{ header: "L_SNDR_NM", binding: "sndrNm", width: "*", required: true }] },
        { cells: [{ header: "L_RCVR_ID", binding: "intfRcvrId", width: "*", required: true }] },
        { cells: [{ header: "L_RCVR_NM", binding: "intfRcvrNm", width: "*", required: true }] },
        { cells: [{ header: "L_API_URL_ADDR", binding: "apiUrlAddr", width: "*", required: true }] },
    ],
    body: [
        { cells: [{ binding: "intfId", type: "text" }] },
        { cells: [{ binding: "intfNm", type: "text" }] },
        { cells: [{ binding: "sndrcvTpCd", type: "code", area: "comnCd", comnCd: "COM0070", viewType: "label" }] },
        { cells: [{ binding: "intfSndrId", type: "text" }] },
        { cells: [{ binding: "sndrNm", type: "text" }] },
        { cells: [{ binding: "intfRcvrId", type: "text" }] },
        { cells: [{ binding: "rcvrNm", type: "text" }] },
        { cells: [{ binding: "apiUrlAddr", type: "text" }] },
    ],
};

export const SF_DOC_BOX_MGMT_SRCH: TFormSchema = {
    id: "form_docBoxMgmtSrch",
    schema: {
        /* Search keyword Select Option !== 검색어 목록 ==!*/
        kwdSel: {
            type: "select",
            label: "L_KWD",
            options: [
                { label: "L_INTF_ID", value: "E" },
                { label: "L_INTF_NM", value: "A" },
                //{ label: "L_SNDR_NM", value: "B" },
                //{ label: "L_RECPT_NM", value: "C" },
                //{ label: "L_API_URL_ADDR", value: "D" },
            ],
        },
        /* Search keyword Select Option Name !== 검색어 ==!*/
        kwdTxt: {
            type: "text",
            readOnly: true,
        },
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_NM",
            all: true,
            area: "comnCd",
            comnCd: "COM0024",
        },
        inexTpCd: {
            type: "select",
            label: "L_INEX_TP_NM",
            all: true,
            area: "comnCd",
            comnCd: "CGM0176",
        },
        actvtYn: {
            type: "select",
            label: "L_ACTVT_YN",
            area: "comnCd",
            comnCd: "COM0064",
        },
    },
};
export const SG_DOC_BOX_MGMT_LIST: TGridSchema = {
    id: "grid_docBoxMgmtList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_INTF_ID", binding: "intfId", width: "*" }] },
        { cells: [{ header: "L_INTF_NM", binding: "intfNm", width: "*" }] },
        { cells: [{ header: "L_SNDR_NM", binding: "sndrNm", width: "*" }] },
        { cells: [{ header: "L_RECPT_NM", binding: "rcvrNm", width: "*" }] },
        { cells: [{ header: "L_API_URL_ADDR", binding: "apiUrlAddr", width: "*" }] },
        { cells: [{ header: "L_INEX_TP_NM", binding: "inexTpCdNm", width: 100 }] },
        { cells: [{ header: "L_BSOP_CLSF_NM", binding: "bsopClsfCdNm", width: "*" }] },
        { cells: [{ header: "L_SNDRCV_TP_NM", binding: "sndrcvTpCdNm", width: 150 }] },
        { cells: [{ header: "L_ACTVT_YN", binding: "actvtYnNm", width: 80 }] },
    ],
    body: [
        { cells: [{ binding: "intfId" }] },
        { cells: [{ binding: "intfNm" }] },
        { cells: [{ binding: "sndrNm" }] },
        { cells: [{ binding: "rcvrNm" }] },
        { cells: [{ binding: "apiUrlAddr", align: "left" }] },
        { cells: [{ binding: "inexTpCdNm" }] },
        { cells: [{ binding: "bsopClsfCdNm" }] },
        { cells: [{ binding: "sndrcvTpCdNm" }] },
        { cells: [{ binding: "actvtYnNm" }] },
    ],
};
